import React from "react";
import { Flex } from "@fluentui/react-northstar";

const SettingsOverlay = (props) => {
    return (
        <Flex className="settingsOverlay" data-testid={props.testid}>
            {props.children}
        </Flex>
    );
};

export default SettingsOverlay;
